// Shared utils & constants for admin sub-pages.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = `${BACKEND_URL}/api/static/images/logo-dark.png`;

export const PRODUCT_LABELS = {
  "mamba-edition": "Mamba Edition",
  "panther-edition": "Panther Edition",
  "glove-bag": "Glove Bag",
};

export const toCsv = (rows, columns) => {
  if (!rows.length) return "";
  const header = columns.join(",");
  const body = rows
    .map((r) =>
      columns
        .map((c) => {
          const v = r[c] ?? "";
          const s = String(v).replace(/"/g, '""');
          return /[",\n]/.test(s) ? `"${s}"` : s;
        })
        .join(",")
    )
    .join("\n");
  return header + "\n" + body;
};

export const downloadCsv = (filename, rows, columns) => {
  const csv = toCsv(rows, columns);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const fmtChf = (n) =>
  n === null || n === undefined ? "—" : `CHF ${Number(n).toFixed(2)}`;
